// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__i6vBy","fadeIn":"Tooltip_fadeIn__t6c1U"};